/**
 * 集成Abstract
 * @date 2020-5-29
 */
import Abstract from './abstract';
import { CancelToken } from "axios";
class Index extends Abstract {

    // 获取验证码
    getTopSystemCode() {
        return this.getReq({ url: 'topsystem/vcode' });
    }

    // 用户登录
    postUserLogin(params: any) {
        return this.postAgencyReq({ url: 'user/login',data:params });
    }

    //获取token
    getAccountToken(params: any){
        return this.postAgencyReq({ url: 'api/oauth2/access_token',data:params })
    }

    // 验证token是否有效
    getVerifyToken(params: any){
        console.log(params,'params')
        return this.getReq({ url: 'api/oauth2/auth',params:params })
    }

    // 判断当前账户是否加安全锁
    postVerifyAccountIsLock(){
        return this.postAgencyReq({ url: 'api/oauth2/security_code/token/islock' })
    }

    // 获取当前登录用户信息 teacher
    getTeacher(){
        return this.getReq({ url: 'account_user/teacher' })
    }

    // 安全验证 当前账号已加锁
    postVerifySendSms(){
        return this.postAgencyReq({url:'api/oauth2/security_code/sms/send'})
    }

    // 用户校验验证码
    smsCodeLogin(smsCode: any){
        return this.postAgencyReq({url:'api/oauth2/security_code/sms/validate/' + smsCode})
    }

    //
    post_unlock_access_token(unlock_access_token: any){
        return this.postAgencyReq({url:'api/oauth2/security_code/unlock_access_token/' + unlock_access_token})
    }

    // 验证collegeId是否正确
    school_security_login(loginName: string,collegeId: any){
        return this.getReq({url:'security_login/login_check/'+ loginName +'/' + collegeId})
    }

    // 验证collegeId是否正确
    get_college_detail(collegeid: any){
        return this.getReq({url:'/college/'+collegeid+'/public'})
    }




    //高校数据大屏-企业数据
    getCooperation(data:any){
        return this.getReq({ url: '/college/screen/cooperation',params:data})
    }
    //重点数据 获取前10信息
    //  get_delivery_stream(): any {
    //     return this.getReq( { url: 'global_data_statistics/delivery_stream'})
    // }
    //重点数据
    get_screen_stream(cancelToken: CancelToken): any {
        return this.getReq( { url: 'college/screen/main', cancelToken})
    }

    //招聘活动数据
    get_screen_milk(data:any):any{
        return this.getReq({url:'college/screen/milk',params:data})
    }

    //生源信息数据
    get_screen_stu(grade:string):any{
        return this.getReq({url:'college/screen/student',params: {year:grade}})
    }
		//学生动态信息数据
    get_stu_action(grade:string):any{
			return this.getReq({url:'college/screen/dynamic_event/list'})
    }

	// 就业情况数据
	get_screen_employment(year:string,facultyid:string,major:string):any{
        return this.getReq({url:'college/screen/employment?year='+year+'&facultyid='+facultyid+'&major='+major})
    }

	//获取字典
	get_dict(type:string):any{
	    return this.getReq({url:'dict/'+type})
	}

	//获取高校当前届别列表
	get_year_list():any{
	    return this.getReq({url:'/college/year_list/has_faculty'})
	}

	//获取当前届别院系列表
    get_faculty_list(collegeid:string,year:string):any{
        return this.getReq({url:'/college/'+collegeid+'/faculty/list/years/public?year='+year})
    }
    get_screen_background(collegeid:string):any{
        return this.getReq({url:'college/screen/background/public?collegeid='+collegeid})
    }

	//获取界别
	get_year_now():any{
	    return this.getReq({url:'college/year_list/now'})
	}
    /** 清除缓存 */
    clear_cache():any{
        return this.postReq({url:'college/screen/clear_cache'})
    }

}

// 单列模式返回对象
let instance;
export default (() => {
    if (instance) return instance;
    instance = new Index();
    return instance;
})();
